
export const config = {
    apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
    environment: process.env.REACT_APP_ENVIRONMENT || 'development',
    
  };